import { render, staticRenderFns } from "./ProjectTestGroup.vue?vue&type=template&id=ea36161a&scoped=true&"
import script from "./ProjectTestGroup.vue?vue&type=script&lang=ts&"
export * from "./ProjectTestGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectTestGroup.vue?vue&type=style&index=0&id=ea36161a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea36161a",
  null
  
)

export default component.exports